/*
 * Copyright (C) 2024 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and
 * should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly
 * prohibited.
 */

import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import DisabledByDefaultRoundedIcon from '@mui/icons-material/DisabledByDefaultRounded';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useState } from 'react';
import { Box, IconButton } from '@mui/material';

export enum TriState {
  Blank = 0,
  Approved,
  Denied,
  Unavailable,
}

export interface TriStateCheckboxProps {
  updateParent?: any;
  value?: string;
  status?: TriState;
  readOnly?: boolean;
  disabled?: boolean;
  sx?: any;
}
const TriStateCheckbox = ({
  updateParent,
  value,
  status = TriState.Unavailable,
  readOnly = true,
  disabled = false,
  sx = undefined,
}: TriStateCheckboxProps) => {
  const [state, setState] = useState<TriState>(status);
  if (readOnly) {
    return <Box sx={sx}>{renderIcon(status, value!)}</Box>;
  } else {
    return (
      <IconButton
        id={value}
        onClick={(e: any) => {
          updateParent(value, cycle(state));
          setState(cycle(state));
        }}
        disabled={disabled || state === TriState.Unavailable}
        sx={sx}
      >
        {renderIcon(state, value!)}
      </IconButton>
    );
  }
};

const renderIcon = (status: TriState, id: string) => {
  switch (status) {
    case TriState.Blank:
      return <CheckBoxOutlineBlankIcon id={id + ' ' + TriState.Blank} htmlColor="white" />;
    case TriState.Approved:
      return <CheckBoxIcon id={id + ' ' + TriState.Approved} htmlColor="#A4D810" />;
    case TriState.Denied:
      return <DisabledByDefaultRoundedIcon id={id + ' ' + TriState.Denied} htmlColor="#E73737" />;
    case TriState.Unavailable:
      return <> -- </>;
    default:
      return <> -- </>;
  }
};

const cycle = (currentState: number) => {
  if (currentState === 2) {
    return 0;
  } else {
    return currentState + 1;
  }
};

export default TriStateCheckbox;
